import React, { useContext } from "react";
import {
  Alert,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const Login = () => {
  const { login, isAuthenticated } = useContext(AuthContext) || {};
  const navigate = useNavigate();

  const [formData, setFormData] = React.useState({
    username: "",
    password: "",
  });

  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<null | string>(null);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
  
    fetch("appservice/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } 
      })
      .then((data) => {
        localStorage.setItem("token", data.token);
  
        if (login) {
          login(data.token);
        }

        navigate('/admin');
      })
      .catch((error) => {
        setError("Credenciales inválidas");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  React.useEffect(()=> {
    if(isAuthenticated) {
      navigate('/admin');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!loading ? (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Inicie sesión
            </Typography>
            <Box
              component="form"
              action="#"
              noValidate
              sx={{ mt: 1, width: "100%" }}
              onSubmit={handleSubmit}
            >
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Correo electrónico"
                name="email"
                autoComplete="email"
                autoFocus
                value={formData.username}
                onChange={(e) =>
                  setFormData((prevState) => ({
                    ...prevState,
                    username: e.target.value,
                  }))
                }
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                value={formData.password}
                onChange={(e) =>
                  setFormData((prevState) => ({
                    ...prevState,
                    password: e.target.value,
                  }))
                }
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
              >
                Iniciar sesión
              </Button>
              {error && <Alert severity="error">{error}</Alert>}
            </Box>
          </Box>
        </Container>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default Login;
